import { BannersEnum } from '../enums/banners.enum';
import { Role } from '../enums/role.enum';
import { UserState } from '../enums/user-state.enum';
import type { CreateUserDto } from './createUserDto.interface';

// eslint-disable-next-line @typescript-eslint/no-type-alias
export interface GetUserDto extends Omit<CreateUserDto, 'acceptPolicy'> {
    referralReferrer?: string;
    state: UserState;
    disabled: boolean;
    roles: Role[];
    id: string;
    hasAcceptedLatestPolicy: boolean;
    createdAt: Date;
    isInvitee: boolean;
    isMe: boolean;
    organizationRole: string;
    isDeleted: boolean;
    dismissedBanners: BannersEnum[];
    lastSeenReleaseId?: string;
}
